import React, { Fragment } from 'react'
import styles from "./EventDetails.module.css"

const EventDetails = () => {
  return (
    <Fragment>EventDetails</Fragment>
  )
}

export default EventDetails